import { CustomClaimValue, useAuth } from "@app/shared";
import { FC } from "react";
import { useAlertsUiVisible } from "../../hooks/useAlertsUiVisible";
import { DashboardLayout } from "../layouts/DashboardLayout";
import { TabbedDashLayout } from "../layouts/TabbedDashLayout";
import { AlertRecipientTable, AlertSubscriptionTable, AlertWebhookTable } from "./notifications";

// Notification settings for device-health alerts: the current user's own subscriptions,
// plus the org-level destinations (free-form email recipients and webhooks) an admin
// manages. One tab per destination type, matching the Integrations and Site Admin pages.
export const NotificationSettings: FC = () => {
    const { currentOrganizationId } = useAuth();
    const visible = useAlertsUiVisible();

    if (!visible) {
        return (
            <DashboardLayout centerChildren="Device Health Notifications">
                <div className="text-muted-body-text">Notifications are not available yet.</div>
            </DashboardLayout>
        );
    }

    return (
        <TabbedDashLayout
            centerChildren="Device Health Notifications"
            tabs={[
                { title: "My Subscriptions", child: <AlertSubscriptionTable organizationId={currentOrganizationId ?? ""} /> },
                { title: "Email Recipients", child: <AlertRecipientTable organizationId={currentOrganizationId ?? ""} />, requiredClaim: CustomClaimValue.SuperAdmin },
                { title: "Webhooks", child: <AlertWebhookTable organizationId={currentOrganizationId ?? ""} />, requiredClaim: CustomClaimValue.SuperAdmin },
            ]}
        />
    );
};
